
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop",
      function () {
        return require("private-next-pages/shop.tsx");
      }
    ]);
  